var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex align-center"},[_c('avatar',{attrs:{"size":36,"path":_vm.site.logo_url,"name":_vm.site.name}}),_c('div',{staticClass:"is-flex flex-column ml-1"},[_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.site.name_and_city ?? _vm.site.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }